import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({attrs:{"disabled":"","color":"primary","depressed":"","href":("https://" + (_vm.value.code)),"target":"_blank"}},'v-btn',_vm.$attrs,false),[_c('div',{staticClass:"d-flex flex-gap-8 align-center"},[_c('span',[_vm._v(_vm._s(_vm.$t('Preview')))]),_c(VIcon,{attrs:{"small":""}},[_vm._v("visibility")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }